var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegisteredMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7081",
    "data-name": "Rectangle 7081",
    width: 56,
    height: 56,
    transform: "translate(716 411)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Registered_mail",
    "data-name": "Registered mail",
    transform: "translate(-716 -411)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28183",
    "data-name": "Group 28183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27080",
    "data-name": "Group 27080",
    transform: "translate(-92.109 -663.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30658",
    "data-name": "Path 30658",
    d: "M820.5,1112.938a2.153,2.153,0,0,1-.289-.227A1.9,1.9,0,0,0,820.5,1112.938Z",
    transform: "translate(0.031 1.023)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30659",
    "data-name": "Path 30659",
    d: "M819.635,1111.74a1.815,1.815,0,0,0,.535.959A2.065,2.065,0,0,1,819.635,1111.74Z",
    transform: "translate(0.004 0.978)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30660",
    "data-name": "Path 30660",
    d: "M819.637,1111.75a1.771,1.771,0,0,1-.04-.221A2,2,0,0,0,819.637,1111.75Z",
    transform: "translate(0.002 0.968)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30661",
    "data-name": "Path 30661",
    d: "M820.21,1112.709c-.021-.018-.044-.035-.064-.053C820.166,1112.676,820.19,1112.691,820.21,1112.709Z",
    transform: "translate(0.028 1.021)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27079",
    "data-name": "Group 27079",
    transform: "translate(819.549 1090.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30662",
    "data-name": "Path 30662",
    d: "M819.555,1095.264l.014,14.287,9.625-7.153Z",
    transform: "translate(-819.549 -1090.786)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30663",
    "data-name": "Path 30663",
    d: "M851.6,1095.233l-9.624,7.153,9.638,7.13Z",
    transform: "translate(-818.493 -1090.787)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30664",
    "data-name": "Path 30664",
    d: "M852.669,1111.727l-.013-.008-11.373-8.413-3.933,2.921-1.237.92-1.239-.917-3.938-2.915-11.356,8.44c0,.057.009.112.017.166a1.421,1.421,0,0,0,.04.22,2.059,2.059,0,0,0,.535.96c.02.019.042.036.063.053a2.153,2.153,0,0,0,.289.227,1.78,1.78,0,0,0,.907.242l29.375-.028a1.884,1.884,0,0,0,1.861-1.863Z",
    transform: "translate(-819.547 -1090.407)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30665",
    "data-name": "Path 30665",
    d: "M851.134,1091.018a1.929,1.929,0,0,0-.347-.031l-29.375.027a1.861,1.861,0,0,0-1.863,1.859v0l.019.015,16.541,12.244,16.518-12.275.02-.015A1.862,1.862,0,0,0,851.134,1091.018Z",
    transform: "translate(-819.549 -1090.987)",
    fill: "#3d72fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28179",
    "data-name": "Group 28179",
    transform: "translate(-52.292 -352.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28182",
    "data-name": "Group 28182",
    transform: "translate(801.129 791.575)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3070",
    "data-name": "Ellipse 3070",
    cx: 9.163,
    cy: 9.163,
    r: 9.163,
    fill: "#53c789"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28181",
    "data-name": "Group 28181",
    transform: "translate(3.962 5.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28179-2",
    "data-name": "Group 28179",
    transform: "translate(2.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31463",
    "data-name": "Path 31463",
    d: "M813.572,807.972l-1.063-1.063,6.158-6.159a.3.3,0,0,1,.426,0l.85.85a.3.3,0,0,1,0,.425L814,807.972A.3.3,0,0,1,813.572,807.972Z",
    transform: "translate(-812.509 -800.663)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28180",
    "data-name": "Group 28180",
    transform: "translate(0 2.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31464",
    "data-name": "Path 31464",
    d: "M811.662,809.359l-3.855-3.855a.3.3,0,0,1,0-.425l.85-.85a.3.3,0,0,1,.425,0l4.067,4.067-1.062,1.063A.3.3,0,0,1,811.662,809.359Z",
    transform: "translate(-807.719 -804.14)",
    fill: "#fff"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisteredMail);
export default __webpack_public_path__ + "static/media/registeredMail.d79c3589fa95ccd6ffbf777c580791ba.svg";
export { ForwardRef as ReactComponent };